import React, { useLayoutEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useUserContext } from "contexts/UserContext";
import ReportPageWrapper from "components/ReportPageWrapper";

import MunicipalQuestionnairePage from "pages/municipal/municipalQuestionnaire/ManagementQuestionnairePage";
import * as questionnaireSubmissionService from "api/services/questionnaireSubmissionService";
import { exportQuestionnaireToWord } from "utils/export";

/**
 * The "asset management" questionnaire page.
 *
 * @returns {React.Component} The page component.
 */
const AssetManagementQuestionnairePage = () => {
  const { year: questionnaireYear } = useParams();
  const { user: currentUser } = useUserContext();

  const municipalityId = currentUser?.municipalityId;

  const [questionnaireResponse, setQuestionnaireResponse] = useState(null);

  const getQuestionnaireData = async () => {
    setQuestionnaireResponse(null);
    const response = await questionnaireSubmissionService.getAssetQuestionnaire(
      municipalityId,
      questionnaireYear
    );
    setQuestionnaireResponse(response);
  };

  useLayoutEffect(() => {
    getQuestionnaireData();
  }, []);

  const headerActions =
    questionnaireResponse != null
      ? [
          {
            testId: "exportQuestionnaire",
            label: "Export",
            variant: "outlined",
            style: { width: "8rem" },
            onClick: () => {
              exportQuestionnaireToWord(
                questionnaireResponse.data.questions,
                `Asset Management Questionnaire ${questionnaireYear}`
              );
            },
          },
        ]
      : null;

  return (
    <ReportPageWrapper
      title="Asset Management Questionnaire"
      headerActions={headerActions}
    >
      <MunicipalQuestionnairePage
        responseOverride={questionnaireResponse}
        dataSaved={getQuestionnaireData}
      />
    </ReportPageWrapper>
  );
};

export default AssetManagementQuestionnairePage;
